import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IGatewayRepository } from '../../repositories/interfaces/iGatewayRepository';
import { IGatewayScreenResponse } from '../../../entity/interface/iGatewayScreen';
import { ScreenData } from '../../entities/ScreenEntities';

export interface IGetGatewayScreenUseCase {
    execute(appKey: string, layout: string, screen: string, params: string): Promise<ScreenData>;
}

export class GetGatewayScreenUseCase implements IGetGatewayScreenUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get gatewayRepository(): IGatewayRepository {
        return container.resolve<IGatewayRepository>(DI.REPOSITORIES.IGatewayRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(appKey: string, layout: string, screen: string, params: string): Promise<ScreenData> {
        const response = await this.gatewayRepository.getGatewayScreen(appKey, layout, screen, params);
        return response;
    }
}
